export { default as BasicModal } from "./BasicModal";
